import React from "react";
import Portal from "./components/portal";
import Login from "./components/login";
import Layout from "./components/layout";
import { Routes, Route } from "react-router-dom";
import PasswordReset from "./components/passwordreset";
import FirstConnexion from "./components/firstconnexion";
import SubscriptionSelection from "./components/subscribe";
import { GeneralProvider } from "./contexts/GeneralContext";
import Registration from "./components/registration";
import ChangePassword from "./components/changepassword";
import Oidc from "./components/oidc";
import { LocaleProvider } from "./contexts/LocaleContext";

function App() {
  return (
    <GeneralProvider>
      <LocaleProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Login />} />
            <Route path="portal" element={<Portal />} />
            <Route path="oidc" element={<Oidc />} />
            <Route path="register/:thematic" element={<Registration />} />
            <Route path="reset" element={<PasswordReset />} />
            <Route path="reset/:email" element={<PasswordReset />} />
            <Route path="firstconnexion/:id/:email/:token" element={<FirstConnexion />} />
            <Route path="payment/:id/:email/:secret/:token" element={<FirstConnexion />} />
            <Route path="resetPassword/:id/:email/:token" element={<ChangePassword />} />
            <Route path="subscribe/liberal" element={<SubscriptionSelection />} />
            <Route path="*" element={<Login />} />
          </Route>
        </Routes>
        </LocaleProvider>
    </GeneralProvider>
  );
}

export default App;